export const BULK_MANAGE_PAGE_TITLE = 'BULK_MANAGE:ADVERTISERS:FOCUS_VIEW:TITLE'
export const BULK_MANAGE_BACK_TO_ACCOUNTS = 'BULK_MANAGE:ADVERTISERS:BACK_TO_ACCOUNTS'
export const BULK_MANAGE_CARD_TITLE = 'BULK_MANAGE:ADVERTISERS:CARD_HEADER'
export const BULK_MANAGE_CARD_DESCRIPTION = 'BULK_MANAGE:ADVERTISERS:CARD_DESCRIPTION'
export const BULK_MANAGE_SUCCESS_ALERT = 'BULK_MANAGE:ADVERTISERS:SUCCESS_ALERT'
export const BULK_MANAGE_ERROR_ALERT = 'BULK_MANAGE:ADVERTISERS:ERROR_ALERT'
